import LoadingButton from "@mui/lab/LoadingButton";
import { Stack, TableCell, TableRow } from "@mui/material";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import api from "../../../../../Apis";
import { useTranslation } from "react-i18next" 
export default function RowFanpageItemNotConnect(props) {
    const { t, i18n } = useTranslation();
    const { data, stt, cookies, index, status } = props;
    const navigation = useNavigate();
    const [state, setState] = useState({
        loading: false
    })

    const connectPage = () => {
        setState({
            ...state,
            loading: true,
        })
        const requestOptions = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + cookies.is_login
            },
            body: JSON.stringify({
                fanpage_id: data.fanpage_id,
                lang: i18n.language
            })
        };
        fetch(api.connect_page, requestOptions)
        .then(res => res.json())
        .then(
            (result) => {
                if (result.success) {
                    Swal.fire(
                        // result.message
                        t("common.alert.connectSuccess")
                        , '', 'success');
                    data["value_status"] = 1;
                    data["value_status_comment"] = 1;
                    props.connected(index, data);
                    setState({
                        ...state,
                        loading: false
                    })
                } else {
                    Swal.fire(result.message, '', 'error');
                    setState({
                        ...state,
                        loading: false
                    })
                }
            }
        )
    }

    return (
        <TableRow
        sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
        >
            <TableCell>{ stt }</TableCell>
            <TableCell>
                <a href={`https://www.facebook.com/${ data.fanpage_id }`} target="_blank">
                    { data.fanpage_id }
                </a>
            </TableCell>
            <TableCell>
                <b>{ data.fanpage_name }</b>
            </TableCell>
            <TableCell align="center">
                <Stack sx={{ marginBottom: "5px" }} spacing={1} direction="row" justifyContent="center" flexWrap="wrap">
                    <LoadingButton onClick={() => connectPage()} loading={ state.loading } className="text-transform" color="primary" variant="contained">{t("common.connectBtnLabel")}</LoadingButton>
                </Stack>
            </TableCell>
        </TableRow>
    )
}